export const load = () => ({
	h1: 'How to Install and Enjoy your Indow Insert',
	title: 'Installation and Resources for Customers',
	description:
		'Have questions about the measurement or installation process of your Indow window insert? Come here for guides and how to videos to care for your insert.',
	showTitle: true,
});
